import { useState, type ReactNode } from 'react';
import ToastContainer, { type ToastPosition } from './ToastContainer';
import type { ToastProps } from './Toast';
import { ToastContext, type Toast } from './ToastContext';

interface ToastProviderProps {
  children: ReactNode;
  position?: ToastPosition;
}

export default function ToastProvider({ children, position = 'bottom-left' }: ToastProviderProps) {
  const [toasts, setToasts] = useState<ToastProps[]>([]);

  const showToast = (toast: Omit<Toast, 'id'>) => {
    const id = Math.random().toString(36).substr(2, 9);
    const newToast: ToastProps = {
      ...toast,
      id,
      onClose: hideToast,
    };

    setToasts((prev) => {
      // By default, only show one toast at a time (allowMultiple defaults to false)
      if (!toast.allowMultiple) {
        return [newToast];
      }
      // If allowMultiple is true, add the new toast to existing ones
      return [...prev, newToast];
    });
  };

  const hideToast = (id: string) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  };

  return (
    <ToastContext.Provider value={{ showToast, hideToast }}>
      {children}
      <ToastContainer toasts={toasts} position={position} onRemoveToast={hideToast} />
    </ToastContext.Provider>
  );
}
